import React, { FC, useEffect, useState } from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import { useRouter } from 'next/router';
import { getDragonData } from '../../../commands/mint/getDragon';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { facade } from '../../../helpers/analytic/AnalyticFacade';
import { CheckDragon } from '../../../helpers/analytic/event/DragonEvent';
import CustomDropdown from './CustomDropdown';
import ShareIcon from '@mui/icons-material/Share';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import TwitterIcon from '@mui/icons-material/Twitter';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PhotoIcon from '@mui/icons-material/Photo';
import CropOriginalIcon from '@mui/icons-material/CropOriginal';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import { downloadImg, downloadImgWithFrame, downloadZipImgs } from "./ImageDownloader";
import axios from 'axios';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { DLDragon } from '../../../helpers/analytic/event/DLDragon';
import { DRAGON_TRAITS_PERCENTAGES } from "../../../helpers/dragonhelper"

//
function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress
                    sx={{
                        "&.MuiLinearProgress-root": {
                            backgroundColor: "#77572f!important",
                            borderRadius: "4px",
                            height: "8px",
                            ".MuiLinearProgress-bar": { backgroundColor: "#0aff0a!important" }
                        }
                    }}
                    variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 30 }}>
                <Typography variant="body2" sx={{ color: "#e94926", fontSize: "11px" }}>{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}

//
function DragonDetails(props: any) {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const [dragon, setDragon] = useState<any>(null); // Dragon used for UI!
    const [dragonMePrice, setDragonMePrice] = useState<any>(null); // Dragon used for UI!
    const router = useRouter();

    const STONE_RUNES_SEQ = [3, 2, 1, 4, 3, 2, 1, 4, 4, 3, 2, 1, 4, 3, 2, 1];
    const SHOW_ATTRS = ["Class", "Affinity", "Spine", "Horns", "Neck", "Face", "Tusk", "Eye"];

    // Loading for download!
    const [loadingDownload, setLoadingDownload] = useState<boolean>(false);

    // Load once on start!
    useEffect(() => {

        facade.sendEvent(new CheckDragon(router.query.mint_id as string));
        onStart();
    }, [props.dragon]);

    //
    function prepareDragon(dragon: any) {
        // Get dna as array
        let dnaAttr = dragon.attributes.find((att: any) => att.trait_type === "DNA");
        let dnaArray: string[] = [];

        if (dnaAttr) {
            for (let i = 0; i < dnaAttr.value.length; i++) {
                dnaArray.push(dnaAttr.value[i]);
            }
        }

        dragon.dnaArray = dnaArray;

        // We dont show all attr
        let attrToShow = [];

        for (let i = 0; i < SHOW_ATTRS.length; i++) {
            let attr = dragon.attributes.find((att: any) => att.trait_type === SHOW_ATTRS[i]);

            if (attr) {
                attrToShow.push(attr);
            }
        }

        dragon.attrToShow = attrToShow;
    }

    // 
    async function onStart() {
        if (props.dragon) {
            let dragon = props.dragon;

            if (dragon) {
                let price = await getMagicEdenPrice(router.query.mint_id as string);
                setDragonMePrice(price)

                prepareDragon(dragon);
                setDragon(dragon);
            }
            else {
                setDragon(undefined);
            }
        }
        else {
            setDragon(undefined);
            console.error("Can't get dragon.");
        }
    }

    //
    const shareSelectHandler = (option: string) => {

        if (option === 'share_copyToCB') {
            navigator.clipboard.writeText(`https://eternaldragons.com/dragon/${dragon.mint}`);
        }
        else if (option === 'share_twitter') {
            window.open(`https://twitter.com/intent/tweet?text=https://eternaldragons.com/dragon/${dragon.mint}`, "_blank");
        }
    };

    //
    const downloadImgSelectHandler = async (option: string) => {
        setLoadingDownload(true);

        if (option === 'download_normal') {
            facade.sendEvent(new DLDragon(dragon.mint));
            await downloadImg(dragon.name, dragon.mint);
        }
        else if (option === 'download_framed') {
            facade.sendEvent(new DLDragon(dragon.mint));
            await downloadImgWithFrame(dragon.name, dragon.mint);
        }
        else if (option === 'download_all') {
            facade.sendEvent(new DLDragon(dragon.mint));
            await downloadZipImgs(dragon.name, dragon.mint);
        }

        setLoadingDownload(false);
    };

    //
    function goToSolscan() {
        window.open(`https://solscan.io/token/${dragon.mint}`, "_blank");
    }

    //
    function goToMagiceden() {
        window.open(`https://magiceden.io/item-details/${dragon.mint}?name=${dragon.name}`, "_blank");
    }

    //
    async function getMagicEdenPrice(mint: string) {
        let price: any = null;

        try {
            let res = await axios.get(`https://api-mainnet.magiceden.dev/v2/tokens/${mint}/listings`);

            if (res.data && res.data.length > 0 && res.data[0].price) {
                price = res.data[0].price;
            }
        }
        catch (e) {
            console.error("Can't check ME info.");
        }

        return price;
    }

    //
    function backBtnHandler() {
        router.back();
    }

    //
    function runesUi() {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", width: "100%", flexWrap: "wrap", padding: "5px" }}>
                {
                    dragon.dnaArray.map((gene: any, i: number) => {
                        return (
                            <Box key={i} sx={{ width: "50px", position: "relative", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <img src={"/mint/Rune_0" + STONE_RUNES_SEQ[i] + ".png"} style={{ width: "55px" }} />
                                <Box sx={{ position: "absolute", color: "#00f1ff", fontSize: "26px", fontWeight: 700, top: "14%" }}>{gene}</Box>
                            </Box>
                        )
                    })
                }

            </Box>
        )
    }

    //
    function footerUi() {
        return (
            <Box sx={{ width: "100%", height: "102px", padding: "10px", boxSizing: "border-box", display: "flex", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                    <Box sx={{ margin: "3px" }}>
                        <CustomDropdown
                            loading={false}
                            onSelect={shareSelectHandler}
                            icon={<ShareIcon sx={{ fontSize: "28px" }} />}
                            options={[
                                { id: "share_copyToCB", label: <><ContentCopyIcon sx={{ marginRight: "10px" }} />Copy to clipboard</> },
                                { id: "share_twitter", label: <><TwitterIcon sx={{ marginRight: "10px" }} />Share on Twitter</> }
                            ]}
                        />
                    </Box>

                    <Box sx={{ margin: "3px" }}>
                        <CustomDropdown
                            loading={loadingDownload}
                            onSelect={downloadImgSelectHandler}
                            icon={<SaveAltIcon sx={{ fontSize: "28px" }} />}
                            options={[
                                { id: "download_normal", label: <><PhotoIcon sx={{ marginRight: "10px" }} /> Download PNG</> },
                                { id: "download_framed", label: <><CropOriginalIcon sx={{ marginRight: "10px" }} /> Download PNG with frame</> },
                                { id: "download_all", label: <><FolderZipIcon sx={{ marginRight: "10px" }} /> Download All (zip)</> }
                            ]}
                        />
                    </Box>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "end", flexDirection: "column" }}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {dragonMePrice && <Box sx={{ marginRight: "10px", fontSize: "15px", color: "white", fontWeight: 700, }}>{dragonMePrice} SOL</Box>}
                        <Box onClick={goToMagiceden} className="button-scale-on-hover" sx={{ margin: "1px", cursor: "pointer" }}><img style={{ height: "30px" }} src="/magiceden_icon.png" /></Box>
                    </Box>

                    <Box onClick={goToSolscan} className="button-scale-on-hover" sx={{ margin: "1px", cursor: "pointer" }}><img style={{ height: "30px" }} src="/solscan_icon.png" /></Box>
                </Box>
            </Box>
        )
    }

    // 
    function headerUi() {
        return (
            <Box sx={{ width: "100%", height: "70px", boxSizing: "border-box", display: "flex", justifyContent: "space-between", alignItems: "end" }}>
                <Box sx={{ cursor: "pointer", color: "#725338", "&:hover": { color: "#59412c" } }} onClick={backBtnHandler}>
                    <ArrowBackIosNewIcon sx={{ fontSize: "22px" }} /> <span style={{ fontWeight: 700, fontSize: "17px", position: "relative", top: "-4px", left: "-5px" }}>Back</span>
                </Box>

                <Box sx={{ fontSize: "17px", color: "#46311f", position: "relative", top: "-3px" }}>
                    Views: {dragon.noViewed}
                </Box>
            </Box>
        )
    }

    //
    function detailsUi() {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row" }}>
                <Box sx={{
                    height: "600px", position: "relative", width: "50px",
                    backgroundImage: "url('/mint/Container_Inventory_Left_02.png')",
                    backgroundSize: "100% 100%",
                    flexShrink: 0
                }}>
                </Box>

                <Box sx={{
                    height: "600px", position: "relative",
                    backgroundImage: "url('/mint/Container_Inventory_Middle_02.png')",
                    backgroundSize: "100% 100%",
                    padding: "7px 0px 100px 0px"
                }}>
                    {headerUi()}
                    {detailsInner()}
                    {footerUi()}
                </Box>

                <Box sx={{
                    height: "600px", position: "relative", width: "50px",
                    backgroundImage: "url('/mint/Container_Inventory_Right_02.png')",
                    backgroundSize: "100% 100%",
                    flexShrink: 0
                }}>
                </Box>
            </Box>
        )
    }

    //
    function detailsInner() {
        return (
            <Box className="details-inner" sx={{ overflowY: "auto", height: "405px", }}>
                <Box sx={{ color: "#edcd96", textAlign: "center", marginTop: "10px", fontSize: "14px" }}>Genesis Dragon</Box>
                <Box sx={{ color: "white", fontWeight: 700, marginBottom: "0px", textAlign: "center", fontSize: "14px" }}>{dragon.name}</Box>

                {/* Image nad attributes */}
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row-reverse", flexWrap: "wrap" }}>
                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        margin: "10px 10px 10px 10px"
                    }}>
                        <img src={"/mint/Frame_" + (dragon.score ? dragon.score.label : "Common") + ".png"} style={{ width: "200px", height: "211px" }} />
                        <img src={dragon.image} style={{ position: "absolute", width: "186px", height: "186px", top: "11px" }} />
                        <Box sx={{ position: "absolute", bottom: "-17px", fontSize: "13px", color: "#cacacf" }}>{dragon.score ? dragon.score.label : ""}</Box>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", flexWrap: "wrap", maxWidth: "450px", marginTop: "10px" }}>
                        {
                            dragon.attrToShow.map((attr: any) => {
                                return (<Box key={attr.trait_type} sx={{ padding: "5px" }}>{attrBox(attr)}</Box>)
                            })
                        }

                        {/* Score */}
                        {dragon.score && <Box sx={{ padding: "5px" }}>{scoreBox(dragon.score)}</Box>}
                    </Box>
                </Box>

                {/* Dna runes */}
                <Box sx={{ marginTop: "10px" }}>
                    <Box sx={{ color: "#edcd96", marginLeft: "15px", fontSize: "13px", fontWeight: 400 }}>DNA:</Box>
                    {runesUi()}
                </Box>
            </Box>
        )
    }

    //
    function attrBox(attr: any) {
        return (
            <Box sx={{ width: "100px", height: "53px", background: "#4d3b25", borderRadius: "4px", padding: "2px 5px 2px 5px" }}>
                <Box sx={{ color: "#9c845f", fontSize: "10px" }}>{attr.trait_type}</Box>
                <Box sx={{ color: "white", textAlign: "center", fontSize: "13px", fotWeight: 700, textTransform: "capitalize" }}><i>{attr.value}</i></Box>
                <Box sx={{ color: "#e94926", fontSize: "10px", position: "relative", bottom: "-1px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {DRAGON_TRAITS_PERCENTAGES[attr.trait_type][attr.value]} have this
                </Box>
            </Box>
        )
    }

    //
    function scoreRow(label: string, val: number, percVal: number, total: boolean) {
        return (
            <Box sx={{ color: "#ffd89c", fontSize: total ? "12px" : "11px", display: "flex", justifyContent: "space-between", flexWrap: "wrap", marginBottom: total ? "0px" : "2px" }}>
                <Box sx={{ width: "130px", fontWeight: total ? 700 : 400, color: total ? "#e94926" : "#ffd89c" }}>
                    {label}:
                </Box>

                <Box sx={{ width: "40px", fontWeight: total ? 700 : 400, color: total ? "#e94926" : "#ffd89c" }}>
                    {val}
                </Box>

                <Box sx={{ flexGrow: 1, minWidth: "100px" }}>
                    <LinearProgressWithLabel value={percVal} />
                </Box>
            </Box >
        )
    }

    //
    function scoreBox(score: any) {
        return (
            <Box className="details-score-cont">
                {scoreRow("Visual Rarity score", score.visual, score.visualPerc, false)}
                {scoreRow("Power", score.power, score.powerPerc, false)}
                {scoreRow("Gene Pool Value", score.gene, score.genePerc, false)}
                {scoreRow("Total Rarity Score", score.total, score.totalPerc, true)}
            </Box>
        )
    }

    // 
    function loadingUi() {
        return (
            <Box sx={{ zIndex: 9999, position: "fixed", top: 0, right: 0, bottom: 0, left: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                <CircularProgress />
            </Box>
        )
    }

    //
    function InfoMsg(props: any) {
        return (
            <Box className="mint-info-box">
                <Box sx={{ color: "#c0c8d3", textAlign: "center", margin: "20px 0px 20px 0px", fontSize: "22px", fontWeight: 700 }}>
                    {props.children}
                </Box>
            </Box>
        )
    }

    // Render
    return (
        <Box className={props.className}>
            <Box sx={{ marginTop: "140px", maxWidth: "1300px", bacground: "grey", display: "flex", flexDirection: "column" }}>
                {dragon && detailsUi()}
                {dragon === null && loadingUi()}
                {dragon === undefined && <InfoMsg>Error loading dragon</InfoMsg>}
            </Box>
        </Box>
    );
}

// Default style!
const DragonDetailsS = styled(DragonDetails)({
    minHeight: "100vh",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "column",
    backgroundImage: "url(/BG_Details.jpg)",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50% 60%",
    height: "1000px",
    padding: "0px 5px 0px 5px",
    color: "#cb7d34",
    ".details-inner": {
        "&::-webkit-scrollbar": {
            width: "10px"
        },
        "::-webkit-scrollbar-track": {
            background: "#896b53"
        },
        "&::-webkit-scrollbar-thumb": {
            background: "#b3957d"
        },
        "&::-webkit-scrollbar-thumb:hover": {
            background: "#b3957d"
        }

    },
    ".details-score-cont": {
        maxWidth: "300px",
        height: "auto",
        background: "#4d3b25",
        borderRadius: "4px",
        padding: "5px",
    },
    ['@media (max-width:580px)']: {
        ".details-score-cont": {
            maxWidth: "210px",
            height: "auto",
            background: "#4d3b25",
            borderRadius: "4px",
            padding: "5px",
        },
    },
    ".button-scale-on-hover": {
        transition: "all .2s linear",
        cursor: "pointer",
        "&:hover": {
            transform: "scale(1.15, 1.1)"
        }
    }
});

// Export
export default DragonDetailsS;
